import React, { useState } from "react";
import styles from "./RsvpStory.module.css";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";

const RsvpStory = () => {
  const RSVP = useSelector(state => state.EventPlanningReducer.RSVP);
  const { state } = useLocation();
  const eventData =  state?.eventData;
  const navigate = useNavigate();
  const [Story, setStory] = useState(RSVP?.story ? RSVP?.story : '')
  const dispatch = useDispatch()

  const next = () => {
      if (!Story) {
          dispatch(showAlert({type: "Error" ,title: 'Story', message: 'Please enter your story.!', status: 400 }))
      }
      else {
          let data = {
              ...RSVP,
              story: Story
          }
          dispatch(setRSVP(data))
          navigate("/events/rsvp/rsvptidbits", {
            state: { headrTitle: "RSVP", eventData: eventData },
          })
          // navigation.navigate("Tidbits")
      }

  }
  return (
    <div>
      <TextHeader text={"3. Our Story"} />
      <div className={styles.middlecontainer}>
        <TextComponent text={"Story"} textClass={styles.text} />
      </div>

      <div className={styles.main_input}>
        <textarea className={styles.mainInput} placeholder="Write story" value={Story} onChange={(e)=>setStory(e.target.value)} />
      </div>
      <SubmitButton
        btnClass={styles.btnClass}
        title="Next"
        onClick={next}
      />
    </div>
  );
};

export default RsvpStory;
